import { useEffect, useState } from "react";
import { Globe, Lock as LockIcon } from "lucide-react";
import api from "../../lib/api";

export default function DevSecurity() {
  const [d, setD] = useState({attempts: [], locked_users: []});
  useEffect(()=>{ api.get("/developer/security").then(r=>setD(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Security</div><h1 className="font-display text-4xl text-white">Security & IP Logs</h1></div>

      <div className="card-luxe p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="overline">Locked Accounts</div>
          <span className="text-xs text-white/40">{d.locked_users.length} users</span>
        </div>
        {d.locked_users.length === 0 ? <div className="text-white/40 text-sm">No locked accounts</div> :
          <div className="space-y-2">{d.locked_users.map(u => (
            <div key={u.id} className="flex justify-between items-center py-2 border-b border-white/5 last:border-0">
              <div><div className="text-white text-sm">{u.email}</div><div className="text-xs text-white/40">{u.locked_reason} · {u.locked_at?.slice(0,16)}</div></div>
              <span className="text-red-400 text-xs">● Locked</span>
            </div>
          ))}</div>
        }
      </div>

      <div className="card-luxe p-6 overflow-x-auto">
        <div className="overline mb-4">Recent Login Attempts</div>
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-luxe text-white/40">
            <tr className="border-b border-white/5"><th className="text-left py-2">Time</th><th className="text-left">Email</th><th className="text-left">IP</th><th className="text-left">Location</th><th>Status</th></tr>
          </thead>
          <tbody>
            {d.attempts.slice(0,50).map(a => (
              <tr key={a.id} className="border-b border-white/5">
                <td className="py-3 text-white/60">{new Date(a.created_at).toLocaleString()}</td>
                <td className="text-white/80">{a.email}</td>
                <td className="font-mono text-xs">{a.ip}</td>
                <td className="text-white/60 text-xs flex items-center gap-1 py-3"><Globe size={11}/>{a.geo?.city ? `${a.geo.city}, ${a.geo.country}` : (a.geo?.country || "—")}</td>
                <td className={a.success? "text-[#32D74B]":"text-red-400"}>{a.success? "✓ Success":"× Failed"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
